import { baseApi } from "@/redux/api/baseApi";
import { TResponseRedux, TUser } from "@/types/types";

export type TQueryParam = {
  name: string;
  value: boolean | React.Key;
};

// https://passionbits-production-assets.s3.ap-south-1.amazonaws.com/client/tech+112@whitepanda.in/profile/home-stuido.webp
// https://passionbits-production-assets.s3.ap-south-1.amazonaws.com/client/tech%2B112%40whitepanda.in/profile/home-stuido.webp
// https://passionbits-production-assets.s3.ap-south-1.amazonaws.com/client/tech+112@whitepanda.in/profile/home-stuido.webp
const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get user
    getMe: builder.query({
      query: (args) => {
        return {
          url: `/user/get-me?email=${encodeURIComponent(args)}`,
          method: "GET",
        };
      },
      providesTags: ["User"],
      transformResponse: (res: TResponseRedux<TUser>, meta) => {
        return {
          data: res.data,
          error: res.error,
        };
      },
    }),

    // Update user
    updateUser: builder.mutation({
      query: ({ email, body }: { email: string; body: Partial<TUser> }) => {
        const fullUrl = `/user/update-user?email=${email}`;
        console.log("Full URL:", fullUrl);

        return {
          url: fullUrl,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["User"],
    }),

    // Update creator profile info
    updateCreator: builder.mutation({
      query: ({ id, body }) => ({
        url: `/creator/update-creator-by-creator/${id}`,
        method: "PUT",
        body: body,
      }),
      invalidatesTags: ["User"],
    }),

    // Get creator status
    getCreatorStatus: builder.query({
      query: (email: string) => {
        return {
          url: `/creator-status/get-creator-status?email=${email}`,
          method: "GET",
        };
      },
      providesTags:['creatorStatus']
    }),

    removeUser: builder.mutation({
      query: (email: string) => ({
        url: `/user/remove-user-from-db?email=${email}`,
        method: "POST",
      }),
      invalidatesTags: ["User"],
    }),

    // Request video change
    requestVideoChange: builder.mutation({
      query: (body) => ({
        url: `/creator/video/request`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["VideoChange",'User'], // or a new tag like 'CreatorVideoReq'
    }),

    // Get video request status
    getVideoChangeStatus: builder.query({
      query: (email: string) => ({
        url: `/creator/video/request/status/${encodeURIComponent(email)}`,
        method: "GET",
      }),
      providesTags: ["VideoChange"],
    }),
  }),
});

export const {
  useGetMeQuery,
  useUpdateUserMutation,
  useUpdateCreatorMutation,
  useGetCreatorStatusQuery,
  useLazyGetCreatorStatusQuery,
  useRemoveUserMutation,
  useGetVideoChangeStatusQuery,
  useRequestVideoChangeMutation
} = userApi;
